import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as crypto from 'crypto-js';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class EdpService {
  constructor(private http: HttpClient, private route: Router) {}

  urlServer: string = 'http://187.191.29.118:2332/edpp/php';
  // urlServer: string = 'http://localhost/edp/php';
  title: string =
    '457870656469656e74654469676974616c507369636f70656461676f6769636f'; // ExpedienteDigitalPsicopedagogico to Hex
  ps: string = '556c7361506163687563614544505078'; // UlsaPachucaEDPPx to Hex

  login(user: any, pwd: any): Observable<any> {
    const body = new URLSearchParams();
    body.set('usuario', user);
    body.set('password', pwd);
    const headers = new HttpHeaders().set(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );
    return this.http.post(`${this.urlServer}/autoriza_login.php`, body, {
      headers,
      responseType: 'text',
    });
  }

  obtenerGrupos(valor: any, periodo: string): Observable<any> {
    const headers = new HttpHeaders({ 'edpp-token': valor });
    const options = { headers };
    return this.http.get(
      `${this.urlServer}/obtener_grupos.php?periodo=${periodo}`,
      options
    );
  }

  obtenerExpediente(valor: any, idGrupo: string): Observable<any> {
    const headers = new HttpHeaders({ 'edpp-token': valor });
    const options = { headers };
    let body = new HttpParams();
    body = body.set('subgrupo', idGrupo);
    return this.http.post(
      `${this.urlServer}/obtener_expedientes.php`,
      body,
      options
    );
  }

  obtenerAlumnos(valor: any, periodo: string): Observable<any> {
    const headers = new HttpHeaders({ 'edpp-token': valor });
    const options = { headers };
    return this.http.get(
      `${this.urlServer}/obtener_lista_alumnos.php?periodo=${periodo}`,
      options
    );
  }

  obtenerSesionesGrupales(valor: any, idGrupo: string): Observable<any> {
    const headers = new HttpHeaders({ 'edpp-token': valor });
    const options = { headers };
    let body = new HttpParams();
    body = body.set('subgrupo', idGrupo);
    return this.http.post(
      `${this.urlServer}/obtener_sesiones_grupales.php`,
      body,
      options
    );
  }

  obtenerDetalleSesionGrupal(valor: any, idSesion: string): Observable<any> {
    const headers = new HttpHeaders({ 'edpp-token': valor });
    const options = { headers };
    let body = new HttpParams();
    body = body.set('idSesion', idSesion);
    return this.http.post(
      `${this.urlServer}/obtener_detalle_sesion_grupal.php`,
      body,
      options
    );
  }

  obtenerListaPersonal() {
    return this.http.get(`${this.urlServer}/obtener_personal.php`);
  }

  actualizaSesionGrupal(valor: any, data: object): Observable<any> {
    const headers = new HttpHeaders({ 'edpp-token': valor });
    const options = { headers };
    let body = new HttpParams();
    body = body.set('data', JSON.stringify(data));
    return this.http.post(
      `${this.urlServer}/actualiza_sesion_grupal.php`,
      body,
      options
    );
  }

  obtenerDatosSubgrupo(valor: any, idSubgrupo: string): Observable<any> {
    const headers = new HttpHeaders({ 'edpp-token': valor });
    const options = { headers };
    let body = new HttpParams();
    body = body.set('subgrupo', idSubgrupo);
    return this.http.post(
      `${this.urlServer}/obtener_datos_subgrupo.php`,
      body,
      options
    );
  }

  registraSesionGrupal(valor: any, data: object): Observable<any> {
    const headers = new HttpHeaders({ 'edpp-token': valor });
    const options = { headers };
    let body = new HttpParams();
    body = body.set('data', JSON.stringify(data));
    return this.http.post(
      `${this.urlServer}/registra_sesion_grupal.php`,
      body,
      options
    );
  }

  obtenerSesionesIndividuales(valor: any, matricula: string): Observable<any> {
    const headers = new HttpHeaders({ 'edpp-token': valor });
    const options = { headers };
    let body = new HttpParams();
    body = body.set('matricula', matricula);
    return this.http.post(
      `${this.urlServer}/obtener_sesiones_individuales.php`,
      body,
      options
    );
  }

  obtenerDatosAlumno(
    valor: any,
    idSubgrupo: string,
    matricula: string
  ): Observable<any> {
    const headers = new HttpHeaders({ 'edpp-token': valor });
    const options = { headers };
    let body = new HttpParams();
    body = body.set('subgrupo', idSubgrupo);
    body = body.set('matricula', matricula);
    return this.http.post(
      `${this.urlServer}/obtener_datos_alumnos.php`,
      body,
      options
    );
  }

  registraSesionIndividual(valor: any, data: object): Observable<any> {
    const headers = new HttpHeaders({ 'edpp-token': valor });
    const options = { headers };
    let body = new HttpParams();
    body = body.set('data', JSON.stringify(data));
    return this.http.post(
      `${this.urlServer}/registra_sesion_individual.php`,
      body,
      options
    );
  }

  obtenerDetalleSesionIndividual(
    valor: any,
    idSesion: string
  ): Observable<any> {
    const headers = new HttpHeaders({ 'edpp-token': valor });
    const options = { headers };
    let body = new HttpParams();
    body = body.set('idSesion', idSesion);
    return this.http.post(
      `${this.urlServer}/obtener_detalle_sesion_individual.php`,
      body,
      options
    );
  }

  actualizaSesionIndividual(valor: any, data: object): Observable<any> {
    const headers = new HttpHeaders({ 'edpp-token': valor });
    const options = { headers };
    let body = new HttpParams();
    body = body.set('data', JSON.stringify(data));
    return this.http.post(
      `${this.urlServer}/actualiza_sesion_individual.php`,
      body,
      options
    );
  }

  comprobarSesion(): any {
    const eddp_token = sessionStorage.getItem('edpp-token');
    const data_usuario = [];
    if (!eddp_token) {
      // alert('No se ha iniciado sesión.\nVuelve para iniciar sesión.');
      this.route.navigate(['/login']);
    } else {
      const token = this.recuperarPalabra(eddp_token);
      data_usuario[0] = token.substring(0, 13);
      data_usuario[1] = token.substring(13, 14);
      data_usuario[2] = token.substring(14, token.length);
      if (
        Date.now() > +data_usuario[0] ||
        !data_usuario[1] ||
        !data_usuario[2]
      ) {
        sessionStorage.removeItem('edpp-token');
        alert('La sesión ha caducado.\nVuelve para iniciar sesión.');
        this.route.navigate(['/login']);
      }
      return true;
    }
  }

  UsuarioRegistra(): any {
    const token = this.recuperarPalabra(sessionStorage.getItem('edpp-token'));
    return token.substring(13, 14) == '2' ? true : false;
  }

  cambiarPalabra(valor: string): string {
    const key = crypto.enc.Hex.parse(this.title);
    const iv = crypto.enc.Hex.parse(this.ps);
    return crypto.AES.encrypt(valor, key, {
      iv,
      padding: crypto.pad.ZeroPadding,
    }).toString();
  }

  recuperarPalabra(valor: any): string {
    const key = crypto.enc.Hex.parse(this.title);
    const iv = crypto.enc.Hex.parse(this.ps);
    return crypto.AES.decrypt(valor, key, {
      iv,
      padding: crypto.pad.ZeroPadding,
    }).toString(crypto.enc.Utf8) as unknown as string;
  }

  obtenerTipoTema(): any {
    return this.http.get(`${this.urlServer}/obtener_tipo_tema.php`);
  }

  obtenerCarreras(): any {
    return this.http.get(`${this.urlServer}/obtener_carreras.php`);
  }

  generarReporte(valor: any, data: object): Observable<any> {
    const headers = new HttpHeaders({ 'edpp-token': valor });
    let body = new HttpParams();
    body = body.set('data', JSON.stringify(data));
    return this.http.post(`${this.urlServer}/generar_reporte.php`, body, {
      headers,
      responseType: 'blob',
      observe: 'response',
    });
  }
}
